// frontend/src/services/playList.js
// Service for managing the user's Play List

import { API_BASE } from "../config/api";
import { httpRequest } from "../utils/httpClient";
import { authService } from "./auth";

/**
 * Fetch the user's Play List.
 * Returns an array of games with { game_id, name, thumbnail, year_published }.
 */
async function fetchPlayList() {
  const res = await httpRequest(`${API_BASE}/profile/collection/playlist`, {
    method: "GET",
    headers: authService.getAuthHeaders(),
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch Play List: ${res.status}`);
  }

  return await res.json();
}

/**
 * Add a game to the user's Play List.
 * If the game is not in the user's collection, it is added as Interested.
 */
async function addToPlayList(gameId) {
  const res = await httpRequest(`${API_BASE}/profile/collection/playlist`, {
    method: "POST",
    headers: {
      ...authService.getAuthHeaders(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ game_id: gameId }),
  });

  if (!res.ok) {
    throw new Error(`Failed to add game to Play List: ${res.status}`);
  }

  return await res.json();
}

/**
 * Remove a single game from the user's Play List.
 */
async function removeFromPlayList(gameId) {
  const res = await httpRequest(`${API_BASE}/profile/collection/playlist/${gameId}`, {
    method: "DELETE",
    headers: authService.getAuthHeaders(),
  });

  if (!res.ok) {
    throw new Error(`Failed to remove game from Play List: ${res.status}`);
  }

  return await res.json();
}

/**
 * Clear the user's entire Play List.
 */
async function clearPlayList() {
  const res = await httpRequest(`${API_BASE}/profile/collection/playlist`, {
    method: "DELETE",
    headers: authService.getAuthHeaders(),
  });

  if (!res.ok) {
    throw new Error(`Failed to clear Play List: ${res.status}`);
  }

  return await res.json();
}

export const playListService = {
  fetchPlayList,
  addToPlayList,
  removeFromPlayList,
  clearPlayList,
};

export default playListService;
